import React from 'react';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { useLoader } from '@react-three/fiber';

import { MeshStandardMaterial } from 'three';

export default function GlfLoader({ MeshPath, col, gltfRef}) {
  const { scene } = useLoader(GLTFLoader, MeshPath);

  // Apply any modifications to the loaded model here, if needed
  scene.traverse((child) => {
    if (child.isMesh) {
      child.castShadow = false;
      child.receiveShadow = false;

      child.material.color.set(col)

      //add temp material
      // const material = new MeshStandardMaterial({ color: "green" }); // Red color
      // child.material = material;

    }
  });

  return <primitive object={scene.clone()} />;
}